import { render, staticRenderFns } from "./r-color-item.vue?vue&type=template&id=6b831370&scoped=true&"
import script from "./r-color-item.vue?vue&type=script&lang=js&"
export * from "./r-color-item.vue?vue&type=script&lang=js&"
import style0 from "./r-color-item.vue?vue&type=style&index=0&id=6b831370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b831370",
  null
  
)

export default component.exports